var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.data.className,attrs:{"href":_vm.data.link}},[_vm._v(" "+_vm._s(_vm.$t(_vm.data.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }